import styled from 'styled-components';
import { StyleColor } from '../../utils/styles-constants';


export const TheaterItem = styled('div')`
	height:100%;
`;

export const TheaterOverlay = styled('div')`
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	z-index: 10;
	background: ${StyleColor.Black};
	transition: opacity .4s cubic-bezier(.25,.8,.25,1);
`;

export const TheaterContainer = styled('div')`
	height: 100%;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Theater/styles.ts